import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useNewCapability } from 'sharedHooks';
import SensorPropertiesComponent from './SensorPropertiesComponent';
import { getModel } from './selectors';
import * as actions from '../sensorActions';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';
import { BATTERY_LEVEL_SUPPORTED_SENSOR_TYPES } from './constants';
import './style.scss';


const SensorPropertiesContainer = (props) => {
    const capability = useNewCapability();
    const { model, actions } = props;
    const hasTrendCapability = capability.hasTrendCapability();

    useEffect(() => {
        return () => {
            // Clear store on unmount so API is re-triggered when user returns to this tab
            actions.clearStore();
        };
    }, []);

    useEffect(() => {
        const details = model.assetDetails?.details;
        const sensorIdentifier = model.sensorProperties?.data?.sensorIdentifier;

        if (
            details &&
            details.sensorIdentifier &&
            details.sensorIdentifier !== sensorIdentifier &&
            props.asset?.isMonitored
        ) {
            actions.getSensorProperties(details.sensorId);
            actions.getSensorGatewayInfo(details.sensorId, hasTrendCapability);
            if (BATTERY_LEVEL_SUPPORTED_SENSOR_TYPES.includes(details.sensorType) && hasTrendCapability) {
                actions.getSensorBatteryLevel(details.sensorId);
            }
        }
    }, [
        model.assetDetails?.details?.sensorId,
        model.assetDetails?.details?.sensorIdentifier,
        model.sensorProperties?.data?.sensorIdentifier,
        props.asset?.isMonitored,
        hasTrendCapability,
    ]);

    return <div id='sensor-properties-tab-container'>
        <SensorPropertiesComponent {...props} />
    </div>;
};


SensorPropertiesContainer.propTypes = {
    model: PropTypes.shape({
        assetDetails: PropTypes.shape({
            details: PropTypes.shape({
                sensorIdentifier: PropTypes.string,
                sensorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                assetIdentifier: PropTypes.string,
            }),
        }),
        sensorProperties: PropTypes.shape({
            data: PropTypes.shape({
                sensorIdentifier: PropTypes.string,
            }),
        }),
    }),
    actions: PropTypes.shape({
        getSensorProperties: PropTypes.func,
        getSensorGatewayInfo: PropTypes.func,
        getGatewayInfo: PropTypes.func,
        getSensorRssiValue: PropTypes.func,
        clearStore: PropTypes.func,
    }),
    asset: PropTypes.shape({
        isMonitored: PropTypes.bool,
    }),
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const sensorPropertiesContainerWithErrorBoundaryTrigger = withErrorBoundaryTrigger(SensorPropertiesContainer);
const SensorPropertiesContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(sensorPropertiesContainerWithErrorBoundaryTrigger);

export default SensorPropertiesContainerConn;
